var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"tipsShow"},[_c('el-image',{staticStyle:{"width":"100px","height":"100px","user-select":"none"},attrs:{"src":"../../static/images/icon/nodata.svg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tips))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }